"use strict";

// Constants
// const API_BASE_URL = "https://app.dusucre-macarons.de";
// const API_BASE_URL = "https://phpstack-747822-3424075.cloudwaysapps.com/variant/v.php";
const API_BASE_URL = "https://shopifyapp.dusucre-macarons.de/v.php";


const GIFT_CARD_RIBBON_VARIANT_ID = 47206122291543;

document.addEventListener("DOMContentLoaded", function () {
  const productConfigurator = document.querySelector(".product-configurator");

  const {
    giftCardMessageEl,
    giftCardMessageInput,
    giftCardRibbonEl,
    giftCardDecoEl,
    giftCardRibbonCheckbox,
  } = {
    giftCardMessageEl: document.querySelector(".product-configurator-gift-cards-input"),
    giftCardMessageInput: document.querySelector(".product-configurator-gift-cards-input textarea"),
    giftCardRibbonEl: document.querySelector(".product-configurator-gift-cards-ribbon"),
    giftCardDecoEl: document.querySelector(".product-configurator-gift-cards-deco"),
    giftCardRibbonCheckbox: document.querySelector(".product-configurator-gift-cards-checkbox input"),
  };

  const productCards = {
    macarons: document.querySelectorAll(".product-configurator-product-card--macarons"),
    packages: document.querySelectorAll(".product-configurator-product-card--packages"),
    giftCards: document.querySelectorAll(".product-configurator-product-card--gift-cards"),
    decoCards: document.querySelectorAll(".product-configurator-product-card--deco-cards"),
    ribbonCards: document.querySelectorAll(".product-configurator-product-card--ribbon-cards"),
    boxes: document.querySelectorAll(".product-configurator-product-card--boxes"),
  };

  const tabs = document.querySelectorAll(".product-configurator-tab");

  const summary = {
    summaryEl: document.querySelector(".product-configurator-summary"),
    listEl: document.querySelector(".product-configurator-summary-list"),
    totalPriceEl: document.querySelectorAll(".product-configurator-summary-total-price span"),
    totalItemsEl: document.querySelectorAll(".product-configurator-summary-total-items .total"),
    maxItemsEl: document.querySelector(".product-configurator-summary-total-items .max"),
    previousTabButton: document.querySelector(".product-configurator-summary-btn--previous"),
    nextTabButton: document.querySelector(".product-configurator-summary-btn--next"),
    openListButton: document.querySelector(".product-configurator-summary-btn--open"),
  };

  const packageStepPopup = document.querySelector(".product-configurator-packages-popup");
  const packageStepPopupCloseBtn = document.querySelector(".product-configurator-packages-popup-btn-close");
  const packageStepPopupAddBtn = document.querySelector(".product-configurator-packages-popup-btn-add");
  const packageStepSkipBtn = document.querySelector(".product-configurator-btn--skip");

  const validationPopupEl = document.querySelector(".product-configurator-popup-error");
  const validationPopupCloseBtn = document.querySelector(".product-configurator-popup-error-btn-close");

  const printsPopup = document.querySelector(".product-configurator-popup-prints");
  const printsPopupList = document.querySelector(".product-configurator-popup-prints-list");
  const printsPopupCloseBtn = document.querySelector(".product-configurator-popup-prints-btn-close");
  const printsPopupAddBtn = document.querySelector(".product-configurator-popup-prints-btn-add");

  const loader = document.querySelector(".product-configurator-loader");

  let currentTab = 0,
    tempCartItems = [],
    tempPackageItems = [],
    tempGiftCardItems = [],
    tempDecoCardItems = [],
    tempRibbonCardItems = [],
    tempBoxItem,
    mergedCartItems = [],
    isMultipleOf12 = false,
    isListOpen = false,
    allInputsFilled = false;

  if (!productConfigurator) return;

  let configuratorName = productConfigurator.dataset.configuratorName;
  let maxBoxSize, isRibbon;

  let totalPrice, totalQuantity;

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-DE", {
      style: "currency",
      currency: "EUR",
    }).format(amount);
  };

  const updateTempCart = (item, quantity) => {
    const {
      productCategory,
      productType,
      variantId,
      productId,
      productName,
      productImage,
      productPrice,
      productSize,
    } = item.dataset;

    const existingItem = mergedCartItems.find(
      (cartItem) => cartItem.variantId === parseInt(variantId)
    );
    const existingGiftCardItemIndex = tempGiftCardItems.findIndex(
      (cartItem) => cartItem
    );
    const existingDecoCardItemIndex = tempDecoCardItems.findIndex(
      (cartItem) => cartItem
    );
    const existingRibbonCardItemIndex = tempRibbonCardItems.findIndex(
      (cartItem) => cartItem
    );

    if (productCategory === "gift-cards" && existingGiftCardItemIndex !== -1) {
      tempGiftCardItems.splice(existingGiftCardItemIndex, 1);
    }

    if (productCategory === "deco-cards" && existingDecoCardItemIndex !== -1) {
      tempDecoCardItems.splice(existingDecoCardItemIndex, 1);
    }

    if (
      productCategory === "ribbon-cards" &&
      existingRibbonCardItemIndex !== -1
    ) {
      tempRibbonCardItems.splice(existingRibbonCardItemIndex, 1);
    }

    if (existingItem) {
      if (quantity >= 1) {
        existingItem.quantity = parseInt(quantity);
      } else {
        if (productCategory === "macarons") {
          const itemToRemove = tempCartItems.indexOf(existingItem);
          tempCartItems.splice(itemToRemove, 1);
        }
        if (productCategory === "packages") {
          const itemToRemove = tempPackageItems.indexOf(existingItem);
          tempPackageItems.splice(itemToRemove, 1);
        }
      }
    } else {
      const productData = {
        variantId: parseInt(variantId),
        id: parseInt(productId),
        title: productName,
        quantity: parseInt(quantity),
        category: productCategory,
        image: productImage,
        price: productPrice,
      };

      if (productCategory === "macarons") {
        tempCartItems.push({
          ...productData,
          type: productType,
          printMessages: [],
        });
      }

      delete productData.items;

      if (productCategory === "packages") {
        tempPackageItems.push(productData);
      }

      if (productCategory === "gift-cards") {
        tempGiftCardItems.push({
          ...productData,
          message: giftCardMessageInput.value,
          ribbon: giftCardRibbonCheckbox.checked,
        });
      }

      if (productCategory === "deco-cards") {
        tempDecoCardItems.push(productData);
      }

      if (productCategory === "ribbon-cards") {
        tempRibbonCardItems.push(productData);
      }

      if (productCategory === "boxes") {
        tempBoxItem = {
          ...productData,
          boxSize: productSize,
        };
      }
    }

    mergedCartItems = [].concat(
      tempCartItems,
      tempPackageItems,
      tempGiftCardItems,
      tempDecoCardItems,
      tempRibbonCardItems
    );

    updateCartSummary(tempCartItems, mergedCartItems, tempBoxItem);
  };

  const calculateNumberOfProducts = () =>
    tempCartItems.reduce((total, item) => total + item.quantity, 0);

  const calculateMaxNumberOfMacarons = () => {
    const numberOfProducts = calculateNumberOfProducts();
    const nearestMultiply = Math.ceil(numberOfProducts / 12) * 12 || 12;

    if (configuratorName === "giveaways") {
      summary.maxItemsEl.innerHTML = `/ ${nearestMultiply}`;
    }
    if (configuratorName === "geschenk") {
      if (!maxBoxSize) return;
      summary.maxItemsEl.innerHTML = `/ ${maxBoxSize}`
    }
  }

  const checkIfMultiplyOf12 = () => {
    const numberOfProducts = calculateNumberOfProducts();
    isMultipleOf12 = numberOfProducts > 0 && numberOfProducts % 12 === 0;
  };

  const handlePopupError = () => {
    validationPopupEl.classList.toggle("active");
  };

  const validate = () => {
    const numberOfProducts = calculateNumberOfProducts();

    if (configuratorName === "selbstabholer") {
      if (currentTab === 0) return false;

      if (numberOfProducts < 1) {
        return true;
      }
    }

    if (configuratorName === "geschenk") {
      if (currentTab === 0) {
        if (!maxBoxSize) {
          return true;
        }
      } else if (
        currentTab === 1 &&
        maxBoxSize &&
        numberOfProducts !== parseInt(maxBoxSize)
      ) {
        return true;
      }
    } else if (currentTab === 0 && !isMultipleOf12) {
      return true;
    }

    return false;
  };

  const updateCartSummaryTotalPrice = (totalPrice) => {
    summary.totalPriceEl.forEach((item) => {
      item.innerHTML = formatCurrency(totalPrice);
    });
  };

  const updateCartSummaryTotalQuantity = (totalQuantity) => {
    summary.totalItemsEl.forEach((item) => {
      item.innerText = totalQuantity;
    });
  };

  const updateCartSummaryItemQuantity = () => {
    summary.listEl.querySelectorAll(".product-configurator-summary-list-item").forEach((item) => {
      const btnQuantityIncrease = item.querySelector(".quantity-increase");
      const btnQuantityDecrease = item.querySelector(".quantity-decrease");
      const quantityInput = item.querySelector(".product-quantity-input");
      const productData = item.querySelector(".product-configurator-data");
      const { variantId, productCategory } = productData.dataset;

      if (["gift-cards", "deco-cards", "ribbon-cards"].includes(productCategory)) {
        btnQuantityIncrease.style.display = btnQuantityDecrease.style.display = "none";
      }

      const updateQuantity = (delta) => {
        const newQuantity = parseInt(quantityInput.innerText) + delta;
        updateCardQuantity(productData, variantId, newQuantity);
        updateTempCart(productData, newQuantity);
      };

      btnQuantityIncrease.addEventListener("click", () => updateQuantity(1));
      btnQuantityDecrease.addEventListener("click", () => updateQuantity(-1));
    });
  }

  const updateCardQuantity = (productData, variantId, quantity) => {
    const productCard = document.querySelector(`[data-card-id='${variantId}']`);
    const productCardQuantityInput = productCard?.querySelector(".product-quantity-input");

    if (productCardQuantityInput) {
      productCardQuantityInput.innerText = quantity;
    }
  };

  const updateCartSummary = (tempCartItems, mergedCartItems, tempBoxItem) => {
    let newMergedCartItems = mergedCartItems;

    summary.listEl.innerHTML = "";

    if (tempBoxItem) {
      newMergedCartItems = mergedCartItems.concat(tempBoxItem);
    }

    totalQuantity = tempCartItems.reduce(
      (item, { quantity }) => item + quantity,
      0
    );
    totalPrice = newMergedCartItems.reduce(
      (item, { price, quantity }) => item + price * quantity,
      0
    );

    mergedCartItems.forEach((cartItem) => {
      if (cartItem.category === "boxes") return;
      const listItem = document.createElement("li");

      listItem.classList.add("product-configurator-summary-list-item");
      listItem.innerHTML = `
          <div>${cartItem.image}</div>
          <div>
            <p class="product-configurator-summary-list-item-title">${cartItem.title}</p>
            <p class="product-configurator-summary-list-item-price">${cartItem.price} €</p>
          </div>
          <div class="product-quantity product-configurator-summary-list-item-quantity"> 
            <button class="product-quantity-btn quantity-decrease">-</button> 
            <span class="product-quantity-input">${cartItem.quantity || 0}</span> 
            <button class="product-quantity-btn quantity-increase">+</button>
          </div>
          <div class="product-configurator-data"
               data-product-category="${cartItem.category}"
               data-variant-id="${cartItem.variantId}"
               data-product-id="${cartItem.id}"
          >
          </div>
      `;

      summary.listEl.appendChild(listItem);
    });

    updateCartSummaryItemQuantity();

    if (configuratorName === "geschenk" && currentTab === 2) {
      toggleQuantityButtons(true);
    }

    updateCartSummaryTotalPrice(totalPrice);
    updateCartSummaryTotalQuantity(totalQuantity);
    calculateMaxNumberOfMacarons();
    checkIfMultiplyOf12();
    validate();
  };

  const handlePopupPrints = () => {
    if (!printsPopupList) return true;

    printsPopupList.innerHTML = "";

    const printItems = tempCartItems.filter(({ type }) => type === "druck");

    if (!printItems.length) return true;

    printItems.forEach((item) => {
      const { image, quantity, printMessages = [] } = item;

      Array.from({ length: quantity }).forEach((_, index) => {
        const listItem = document.createElement("li");
        listItem.classList.add("product-configurator-popup-prints-list-item");

        listItem.innerHTML = `
        <div>${image}</div>
        <input type="text" maxlength="10" placeholder="Wunschtext" value="${printMessages[index] || ''}">
      `;

        const inputField = listItem.querySelector("input");

        inputField.addEventListener("change", function () {
          printMessages[index] = this.value;
        });

        inputField.addEventListener("input", function () {
          if (!this.value.trim()) {
            this.classList.add("invalid");
            allInputsFilled = false;
          } else {
            this.classList.remove("invalid");
            allInputsFilled = true;
          }
        });

        if (!inputField.value.trim()) {
          inputField.classList.add("invalid");
          allInputsFilled = false;
        }

        printsPopupList.appendChild(listItem);
      });
    });

    if (allInputsFilled) {
      printsPopup.classList.remove("active");
    } else {
      printsPopup.classList.add("active");
    }

    return allInputsFilled;
  };

  const removeActiveClass = () => {
    tabs.forEach((tab) => tab.classList.remove("active"));
  };

  const toggleQuantityButtons = (disable) => {
    summary.listEl.querySelectorAll(".product-configurator-summary-list-item").forEach(item => {
      const btnQuantityIncrease = item.querySelector(".quantity-increase");
      const btnQuantityDecrease = item.querySelector(".quantity-decrease");
      const productData = item.querySelector(".product-configurator-data");
      const { productCategory } = productData.dataset;

      if (productCategory === "macarons") {
        btnQuantityIncrease.style.display = btnQuantityDecrease.style.display = disable ? "none" : "block";
      }
    });
  };

  const navigateTab = (next) => {
    removeActiveClass();
    currentTab += next ? 1 : -1;
    tabs[currentTab].classList.add("active");
    window.scrollTo({ top: 0, behavior: "smooth" });
    updateSummaryButtonText();
  };

  const previousTab = () => {
    if (currentTab <= 0) return;

    if (configuratorName === "geschenk") {
      toggleQuantityButtons(false);
    }

    navigateTab(false);
  };

  const nextTab = () => {
    const validationErrors = validate();

    if (validationErrors) return handlePopupError();

    const allPrintsValid = handlePopupPrints();
    if (!allPrintsValid) return;

    if (configuratorName === "geschenk" && currentTab === 1) {
      toggleQuantityButtons(true);
    }

    if (configuratorName === "giveaways") {
      currentTab++;
      if (currentTab === 1) {
        packageStepPopup.classList.add("active");
      } else {
        addItemsToCheckout();
      }
      return;
    }

    if (currentTab + 1 === tabs.length) {
      addItemsToCheckout();
    } else {
      navigateTab(true);
    }
  };

  const increaseQuantity = (quantityInput, productData) => {
    let quantityNew = quantityInput.innerText;

    quantityNew++;
    quantityInput.innerText = quantityNew;

    updateTempCart(productData, quantityNew);
  };

  const decreaseQuantity = (quantityInput, productData) => {
    let quantityNew = quantityInput.innerText;

    if (quantityNew <= 0) return;

    quantityNew--;
    quantityInput.innerText = quantityNew;

    updateTempCart(productData, quantityNew);
  };

  const handleListOpen = () => {
    if (mergedCartItems.length <= 0) return;

    isListOpen = !isListOpen;
    summary.listEl.style.display = isListOpen ? "block" : "none";
    summary.openListButton.classList.toggle("active");
  };

  const toggleLoader = () => {
    loader.classList.toggle("hidden");
  }

  const updateSummaryButtonText = () => {
    if (configuratorName === "geschenk") {
      summary.nextTabButton.innerText = "Weiter";

      if (currentTab === 2) {
        summary.nextTabButton.innerText = "In den Warenkorb";
      }
    }
  }

  const addItemsToCheckout = async () => {
    const packageGuid = guid(6);
    let cartPayload = {};

    cartPayload.items = [];

    const bundleType = configuratorName === "selbstabholer" ? "box2" : "box";

    toggleLoader();

    const items = tempBoxItem ? [...tempCartItems, tempBoxItem] : tempCartItems;
    const datePickerHeader = document.querySelector('#header-date-picker');
    const extra_price = (datePickerHeader && datePickerHeader.dataset.discountprice) ? datePickerHeader.dataset.discountprice : 0;
    const discount_text = datePickerHeader.dataset.discounttext;
    const discount_price_text = datePickerHeader.dataset.discountpricetext;
    const totalBoxQuantity = tempCartItems.reduce((item, { quantity }) => item + quantity, 0);
    
    const totalPrice = items.reduce((total, { price, quantity }) => total + price * quantity, 0) + parseFloat(extra_price);

    const headers = {
      Accept: "application/json",
    };

    await fetch(`${API_BASE_URL}?totalPrice=${totalPrice.toFixed(2)}&type=${bundleType}`, {
      method: "POST",
      headers,
    })
      .then((res) => res.json())
      .then((data) => {
        cartPayload = {
          "id": data.variant_id,
          "quantity": 1,
        "properties": {
            ...(tempBoxItem && {
              "Geschenkbox": tempBoxItem.title
            }),
            ...tempCartItems.reduce((acc, item, index) => {
              acc[`${item.title}\n${
                item.printMessages ? item.printMessages.join("\n") : ""
              }`] = `x${item.quantity}`;
              return acc;
            }, {}),
            "_variants": tempCartItems.map(item => item.variantId).join(", "),
            "Stückzahl": tempBoxItem ? tempBoxItem.boxSize : totalBoxQuantity,
            "BoxID": packageGuid,
            [discount_text]: discount_price_text,
          },
          "items": [],
        };
      })
      .catch((error) => {
        console.error(error);
      });

    if (tempPackageItems.length > 0) {
      tempPackageItems.reduce((acc, item) => {
        cartPayload.items.push({
          "id": item.variantId,
          "quantity": parseInt(item.quantity),
          "properties": {
            [item.title]: `x${item.quantity}`,
            "BoxID": packageGuid
          }
        });
        acc[item.title] = `x${item.quantity}`;

        return acc;
      }, {});
    }

    if (tempGiftCardItems.length > 0) {
      tempGiftCardItems.forEach((item) => {
        cartPayload.items.push({
          "id": item.variantId,
          "Anzahl": item.quantity,
          "properties": {
            ...(item.message && { Grußtext: item.message }),
            "BoxID": packageGuid,
          },
        });
      });
    }

    if (tempDecoCardItems.length > 0) {
      tempDecoCardItems.forEach((item) => {
        cartPayload.items.push({
          "id": item.variantId,
          "Anzahl": item.quantity,
          "properties": {
            "BoxID": packageGuid,
          },
        });
      });
    }

    if (giftCardRibbonCheckbox?.checked) {
      cartPayload.items.push({
        "id": GIFT_CARD_RIBBON_VARIANT_ID,
        "Anzahl": 1,
        "properties": {
          "BoxID": packageGuid,
        },
      });
    }

    if (Object.keys(cartPayload).length === 0) {
      delete cartPayload.items;
    }

    await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(cartPayload),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // If the response status is not in the success range, reject the promise with the status text
          return response.json().then((errorData) => {
            return Promise.reject(
              `HTTP error! Status: ${response.status}, ${
                response.statusText
              }. Error: ${JSON.stringify(errorData)}`
            );
          });
        }
      })
      .then((data) => {
        setTimeout(function () {
          window.location.href = "/cart";
        }, 500);
      })
      .catch((error) => {
        toggleLoader();
        console.error("Error:", error);
      });
  };

  const guid = (len = 32) => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    return Array(len).fill().map(() => chars.charAt(Math.floor(Math.random() * chars.length))).join('');
  };

  function addEventListenersToProductCard(
    card,
    productData,
    quantityInput,
    quantityIncreaseBtn,
    quantityDecreaseBtn,
  ) {
    quantityIncreaseBtn.addEventListener("click", () =>
      increaseQuantity(quantityInput, productData)
    );
    quantityDecreaseBtn.addEventListener("click", () =>
      decreaseQuantity(quantityInput, productData)
    );
  }

  // productCards.macarons.forEach((card) => {
  //   const productData = card.querySelector(".product-configurator-data"),
  //     productInfoBtn = card.querySelector(
  //       ".product-configurator-product-card-info-btn"
  //     ),
  //     productInfoBtnClose = card.querySelector(
  //       ".product-configurator-product-card-info-btn-close"
  //     ),
  //     productInfoEl = card.querySelector(
  //       ".product-configurator-product-card-info"
  //     ),
  //     quantityInput = card.querySelector(".product-quantity-input"),
  //     quantityIncreaseBtn = card.querySelector(".quantity-increase"),
  //     quantityDecreaseBtn = card.querySelector(".quantity-decrease");

  //   const handleProductInfoModal = () => {
  //     productInfoEl.classList.toggle("hidden");
  //   };

  //   addEventListenersToProductCard(
  //     card,
  //     productData,
  //     quantityInput,
  //     quantityIncreaseBtn,
  //     quantityDecreaseBtn
  //   );
  //   productInfoBtn.addEventListener("click", () => handleProductInfoModal());
  //   productInfoBtnClose.addEventListener("click", () =>
  //     handleProductInfoModal()
  //   );
  // });

  productCards.macarons.forEach((card) => {
    const productData = card.querySelector(".product-configurator-data"),
    productInfoBtn = card.querySelector(".product-configurator-product-card-info-btn"),
    productInfoBtnClose = card.querySelector(".product-configurator-product-card-info-btn-close"),
    productInfoEl = card.querySelector(".product-configurator-product-card-info"),
    
    quantityInput = card.querySelector(".product-quantity-input"),
    quantityIncreaseBtn = card.querySelector(".quantity-increase"),
    quantityDecreaseBtn = card.querySelector(".quantity-decrease"),

    popupQuantityInput = productInfoEl.querySelector(".product-quantity-input"),
    popupIncreaseBtn = productInfoEl.querySelector(".quantity-increase"),
    popupDecreaseBtn = productInfoEl.querySelector(".quantity-decrease");

    const variantId = productData.dataset.variantId;

    const openInfoModal = () => {
      productInfoEl.classList.remove("hidden");
      popupQuantityInput.innerText = quantityInput.innerText;
    };

    const closeInfoModal = () => {
      productInfoEl.classList.add("hidden");
    };

    const increaseQty = (inputEl) => {
      let qty = parseInt(inputEl.innerText);
      qty++;
      inputEl.innerText = qty;
      updateTempCart(productData, qty);
    };

    const decreaseQty = (inputEl) => {
      let qty = parseInt(inputEl.innerText);
      if (qty <= 0) return;
      qty--;
      inputEl.innerText = qty;
      updateTempCart(productData, qty);
    };

    quantityIncreaseBtn.addEventListener("click", () => {
      increaseQty(quantityInput);
      popupQuantityInput.innerText = quantityInput.innerText;
    });

    quantityDecreaseBtn.addEventListener("click", () => {
      decreaseQty(quantityInput);
      popupQuantityInput.innerText = quantityInput.innerText;
    });

    popupIncreaseBtn.addEventListener("click", () => {
      increaseQty(popupQuantityInput);
      quantityInput.innerText = popupQuantityInput.innerText;
    });

    popupDecreaseBtn.addEventListener("click", () => {
      decreaseQty(popupQuantityInput);
      quantityInput.innerText = popupQuantityInput.innerText;
    });

    productInfoBtn.addEventListener("click", openInfoModal);
    productInfoBtnClose.addEventListener("click", closeInfoModal);
    productInfoBtnClose.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") closeInfoModal();
    });

    productInfoEl.addEventListener("click", (e) => {
      if (e.target === productInfoEl) closeInfoModal();
    });
  });

  productCards.packages.forEach((card) => {
    const productData = card.querySelector(".product-configurator-data"),
      quantityInput = card.querySelector(".product-quantity-input"),
      quantityIncreaseBtn = card.querySelector(".quantity-increase"),
      quantityDecreaseBtn = card.querySelector(".quantity-decrease");

    addEventListenersToProductCard(
      card,
      productData,
      quantityInput,
      quantityIncreaseBtn,
      quantityDecreaseBtn
    );
  });

  productCards.giftCards.forEach((card) => {
    const productData = card.querySelector(".product-configurator-data");
    const giftCardMessageBtnClose = document.querySelector(".product-configurator-gift-cards-input-btn-close");
    const giftCardMessageBtnSave = document.querySelector(".product-configurator-gift-cards-input-btn-save");

    card.addEventListener("click", (e) => {
      const parent = card.parentElement;

      updateTempCart(productData, 1);

      for (const child of parent.children) {
        if (child !== card) child.classList.remove("active");
      }

      card.classList.toggle("active");

      if (card.classList.contains("active")) {
        giftCardMessageEl.classList.remove("hidden");
      } else {
        giftCardMessageEl.classList.add("hidden");
      }
    });

    giftCardMessageBtnClose.addEventListener("click", () => {
      giftCardMessageInput.value = "";
      giftCardMessageEl.classList.add("hidden");
    });

    giftCardMessageBtnSave.addEventListener("click", () => {
      giftCardMessageEl.classList.add("hidden");
    });

    giftCardMessageInput.addEventListener("input", () => {
      const existingItem = tempGiftCardItems.find((cartItem) => cartItem);

      if (existingItem) {
        existingItem.message = giftCardMessageInput.value;
      }
    });

    giftCardRibbonCheckbox.addEventListener("change", () => {
      const existingItem = tempGiftCardItems.find((cartItem) => cartItem);

      if (existingItem) {
        existingItem.ribbon = giftCardRibbonCheckbox.checked;
      }
    });
  });

  productCards.ribbonCards.forEach((card) => {
    const productData = card.querySelector(".product-configurator-data");

    giftCardRibbonCheckbox.addEventListener("change", () => {
      updateTempCart(productData, 1);

      card.classList.toggle("active");
    });
  });

  productCards.decoCards.forEach((card) => {
    const productData = card.querySelector(".product-configurator-data");

    card.addEventListener("click", (e) => {
      const parent = card.parentElement;

      updateTempCart(productData, 1);

      for (const child of parent.children) {
        if (child !== card) child.classList.remove("active");
      }

      card.classList.toggle("active");
    });

    giftCardRibbonCheckbox.addEventListener("change", () => {
      if (isRibbon === "false") return;

      if (giftCardRibbonCheckbox.checked) {
        giftCardDecoEl.classList.remove("hidden");
      } else {
        giftCardDecoEl.classList.add("hidden");
        card.classList.remove("active");

        if (tempDecoCardItems.length > 0) {
          updateTempCart(productData, 0);
        }
      }
    });
  });

  productCards.boxes.forEach((card) => {
    const productData = card.querySelector(".product-configurator-data");
    const { productSize, productRibbon } = productData.dataset;

    card.addEventListener("click", (e) => {
      maxBoxSize = productSize;
      isRibbon = productRibbon;

      if (isRibbon === "true") {
        giftCardDecoEl.classList.add("hidden");
      } else {
        giftCardRibbonEl.classList.add("hidden");
      }

      updateTempCart(productData, 1);
      calculateMaxNumberOfMacarons();

      nextTab();
    });
  });

  calculateMaxNumberOfMacarons();
  updateSummaryButtonText();

  summary.previousTabButton?.addEventListener("click", previousTab);
  summary.nextTabButton?.addEventListener("click", nextTab);
  summary.openListButton?.addEventListener("click", handleListOpen);
  packageStepSkipBtn?.addEventListener("click", nextTab);
  packageStepPopupCloseBtn?.addEventListener("click", () => {
    tempPackageItems = [];
    packageStepPopup.classList.remove("active");
    addItemsToCheckout();
  });
  packageStepPopupAddBtn?.addEventListener("click", addItemsToCheckout);
  validationPopupCloseBtn?.addEventListener("click", handlePopupError);
  printsPopupCloseBtn?.addEventListener("click", () => {
    printsPopup.classList.remove("active");
  })
  printsPopupAddBtn?.addEventListener("click", nextTab);
});

